import { colors } from "./colors"

export const borders = {
  thin: `1px solid ${colors.darkGreen}`,
  darkGreen: `1px solid ${colors.darkGreen}`,
}
